import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import { Enums } from '../../services';
import { getCcsCountries, getCialCountries, getSortedCountries } from './enumSelectors';

var withEnums = function withEnums() {
  for (var _len = arguments.length, enumList = new Array(_len), _key = 0; _key < _len; _key++) {
    enumList[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var getEnumSelectorMap = function getEnumSelectorMap(enums) {
      return {
        countryRegions: enums.countryRegions,
        countries: getSortedCountries(enums),
        cialCountries: getCialCountries(enums),
        ccsCountries: getCcsCountries(enums),
        importsExports: enums.importsExports,
        legalStructures: enums.legalStructures,
        linesOfBusiness: enums.linesOfBusiness,
        reasonsOfRequest: enums.reasonsOfRequest,
        userRoles: enums.userRoles,
        currencies: enums.currencies
      };
    };

    return /*#__PURE__*/function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, _class);

        var _temp;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
          enumSelectorMap: undefined
        }, _this.filterEnums = function () {
          var enumSelectorMap = _this.state.enumSelectorMap;
          return enumList.reduce(function (mappedProps, enumName) {
            mappedProps[enumName] = enumSelectorMap[enumName];
            return mappedProps;
          }, {});
        }, _temp));
      }

      _createClass(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          Enums.getEnums().then(function (enums) {
            var enumSelectorMap = getEnumSelectorMap(enums);

            _this2.setState({
              enumSelectorMap: enumSelectorMap
            });
          });
        }
      }, {
        key: "render",
        value: function render() {
          var enumSelectorMap = this.state.enumSelectorMap;

          if (!enumSelectorMap) {
            return null;
          }

          var filteredEnums = this.filterEnums();
          return React.createElement(WrappedComponent, _extends({}, this.props, filteredEnums));
        }
      }]);

      return _class;
    }(Component);
  };
};

export default withEnums;